<template>
  <div>
    <div class="inst-title">생산 가능 크기 검사</div>
    <pre class="inst-desc">
생산 장비 하나로 한 번에 만들기 힘든 경우 생산 가능 크기 검사 실패가 나오게 됩니다. 
이 경우 완전히 제조가 불가능한 것은 아니기에 '한양3D팩토리 홈페이지 > 문의하기' 로 글을 남겨주시면 생산 가능한 가이드를 제공 해드립니다. </pre
    >

    <div class="inst-subtitle">[해결방법]</div>

    <pre
      class="inst-desc"
    >· 모델을 분할하여 재접합<br>· 한양3D팩토리 문의하기 를 통해 생산가이드 제공 받기</pre>
  </div>
</template>

<script setup></script>
